module.exports = __webpack_public_path__ + "static/img/2_2_1.a2abf105.jpg";